import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavigationService } from '../../services/navigation/navigation.service';
import { CacheService } from '../../services/cache/cache.service';
import { CommonService } from '../../services/common/common.service';
import { Column } from '../interfaces/column.interface';
import moment from 'moment';
// import { UsersDataService } from './users-data.service';
import { User, UsersResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class IngredientsColumnsService {

  public users: User[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};

  constructor(
    private translate: TranslateService,
    private navigation: NavigationService,
    private cache: CacheService,
    private common: CommonService,
    // private usersDataService: UsersDataService,

  ) {
    // this.getUsers()
  }

  // getUsers(offset: number = 0): void {
  //   const cacheKey: string = 'users.cache'
  //   const cache: any = this.cache.get(cacheKey);
  //   if (cache !== null && offset === 0) {
  //     this.users = cache.results
  //     return;
  //   }
  //   const parameters = Object.assign(this.defaultParameters, {offset: offset + ''});
  //   this.usersDataService.getUsers(parameters).subscribe((response: UsersResult|any) => {
  //     if (response !== null) {
  //       if (offset === 0) {
  //         this.users = response.results;
  //       } else {
  //         this.users = this.users.concat(response.results);
  //       }
  //       if (response.inlineCount > this.users.length) {
  //         offset = offset + parseInt(this.defaultParameters.limit + '', 10);
  //         this.getUsers(offset);
  //       }
  //       response.results = this.users;
  //       this.cache.set(cacheKey, response);
  //     }
  //   });
  // }

  getColumns(): Column[] {
    return [
      { field: 'id', sortField: 'id', title: this.translate.instant('ID'), show: (this.navigation.getParamValue('ingredients.id.showFiled', true) && true), displayInList: true, type: 'numericValue'},
      { field: 'name', sortField: 'name', title: this.translate.instant('NAME'), show: (this.navigation.getParamValue('ingredients.name.showFiled', true) && true), displayInList: true, type: 'textValue'},
      { field: 'nameAr', sortField: 'nameAr', title: this.translate.instant('NAMEAR'), show: (this.navigation.getParamValue('ingredients.nameAr.showFiled', true) && true), displayInList: true, type: 'textValue'},
      { field: 'nameFr', sortField: 'nameFr', title: this.translate.instant('NAMEFR'), show: (this.navigation.getParamValue('ingredients.nameFr.showFiled', true) && true), displayInList: true, type: 'textValue'},
      { field: 'imagePath', sortField: 'imagePath', title: this.translate.instant('PICTURE'), show: (this.navigation.getParamValue('ingredients.imagePath.showFiled', false) && true), displayInList: true, type: 'imgValue'},
      { field: 'createdAt', sortField: 'createdAt', title: this.translate.instant('CREATEDAT'), show: (this.navigation.getParamValue('ingredients.createdAt.showFiled', false) && true), displayInList: true, type: 'dateValue', valueFormatter: this.translate.instant('DATETIMEFORMAT')},
      { field: 'creatorUser', title: this.translate.instant('CREATORUSER'), type: 'linkValue', filterData: this.users, show: (this.navigation.getParamValue('ingredients.creatorUser.showFiled', false) && true), displayInList: true, filterField: 'creatorUser.id', displayField: 'username', sortField: 'creatorUser.username', url: 'users' },
      { field: 'modifiedAt', sortField: 'modifiedAt', title: this.translate.instant('MODIFIEDAT'), show: (this.navigation.getParamValue('ingredients.modifiedAt.showFiled', false) && true), displayInList: true, type: 'dateValue', valueFormatter: this.translate.instant('DATETIMEFORMAT')},
      { field: 'actions', title: this.translate.instant('CONTENT.ACTIONS'), type: 'static', show: true, displayInList: true, sortField: null},
    ];
  }

  format(fieldName: string, value: any) {
    if (fieldName.toLowerCase().indexOf('time') > -1) {
      return moment(value).format('YYYY-MM-DD HH:mm');
    } else if (fieldName.toLowerCase().indexOf('date') > -1) {
      return moment(value).format('YYYY-MM-DD');
    }
    return value;
  }

}
